/* global storageAvailable */
var sessionStorageAvailable = storageAvailable.checkSessionStorage();

jQuery(document).ready(function($) {
    var $banners = $('.bocss-banner');
    var docHeight = $(document).height();
    var footerHeight = $('#foot-nav').outerHeight();
    var $window = $(window);

    var bannersStatus = [];
    $banners.each(function(idx, banner) {

        var $banner = $(banner);
        var bannersStatusItem = {
            key: "showBanner" + banner.id,
            banner: $banner,
            dismiss: $banner.find('.bocss-banner__dismiss'),
            showBanner: true
        };

        // Check session storage
        if (sessionStorageAvailable) {
            var userPref = sessionStorage.getItem(bannersStatusItem.key);
            if (userPref === 'false') {
                bannersStatusItem.showBanner = false;
            }
        }

        // Click event for dismissing
        bannersStatusItem.dismiss.click(function() {
            if (typeof(Storage) !== 'undefined') {
                bannersStatusItem.banner.removeClass('bocss-banner--active');
                if (sessionStorageAvailable) {
                    sessionStorage.setItem(bannersStatusItem.key, false);
                }
                bannersStatusItem.showBanner = false;
                checkPosition();
            }
        });

        bannersStatus.push(bannersStatusItem);
    });

    var checkPosition = function() {
        var scrollTop = $window.scrollTop();
        var fromBottom = Math.floor(docHeight - scrollTop - $window.height());
        var shift = 0;
        bannersStatus.forEach(function(bannerItem) {
            if (bannerItem.showBanner) {
                if (scrollTop <= 0 || fromBottom <= footerHeight) {
                    bannerItem.banner.removeClass('bocss-banner--active')
                        .css('margin-bottom', "");
                } else {
                    bannerItem.banner.addClass('bocss-banner--active')
                        .css('margin-bottom', shift)
                        .css('z-index', 1000 - shift);
                    shift += bannerItem.banner.outerHeight();
                }
            }
        });
    };

    // Check the position initially
    checkPosition();

    // Check on scroll as well
    $window.scroll(checkPosition);
});
